export default __webpack_public_path__ + "static/media/mlLogo.49f219c9.png";